<template>
  <div class="gallery-block__wrap">
    <v-row
      ref="gallery"
      wrap
      class="gallery-block"
    >
      <v-col
        v-for="(image, idx) in images"
        v-show="idx < 6"
        :key="idx"
        tag="a"
        :sm="checkIndex(idx)"
        cols="12"
        :href="image.url"
        class="pa-2"
      >
        <!--
        We use v-show because of the way gallery operates.
        It takes its data from dom, so we have all object set-up.
        -->
        <div class="image-card lazy-image__wrap">
          <img
            class="lazy-image"
            :src="image.url"
            alt=""
          >
          <div
            class="image-card__caption"
          >
            {{ image.caption }}
          </div>
        </div>
      </v-col>
    </v-row>

    <v-btn
      v-if="images.length > 5"
      class="show-all-button"
      color="white"
      size="small"
      @click.prevent.stop="openGallery"
    >
      Show all photos
    </v-btn>
  </div>
</template>

<script lang="ts">
import 'lightgallery.js'
import 'lg-thumbnail.js'
import { Vue, Component, Prop } from 'vue-facing-decorator'

declare global {
  interface Window {
    lightGallery: any;
  }
}

@Component({})
export default class GalleryWidget extends Vue {
  @Prop({ type: Array }) images!: { caption: string, url: string }[]

  checkIndex (idx: number) {
    return idx === 0 || idx === 5 ? 6 : 3
  }

  async openGallery () {
    ((this.$refs.gallery as any).$el as HTMLElement).querySelector('a').click()
  }

  mounted () {
    window.lightGallery((this.$refs.gallery as any).$el, {
      enableTouch: true,
      thumbnail: true,
      enableThumbSwipe: true,
    })
  }
}
</script>

<style lang="scss" scoped>
@import '~lightgallery.js/dist/css/lightgallery.css';

.image-card {
  height: 100%;
  overflow: hidden;
  border-radius: 2px;
  cursor: pointer;
  position: relative;
  max-height: 310px;

  img {
    display: block;
    height: 100%;
    width: 100%;
    object-fit: cover;
  }

  &__caption {
    /*background: linear-gradient(0deg, rgba(37, 38, 49, 0.55), rgba(37, 38, 49, 0.55));*/
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    color: #fff;
    font-weight: 500;
    font-size: 1.25rem;
    transition: all 0.2s ease;
    background-color: rgba(0, 0, 0, 0.5);
  }

  &:hover {
    .image-card__caption {
      opacity: 1;
    }
  }
}

.gallery-block__wrap {
  position: relative;

  .show-all-button {
    position: absolute;
    bottom: 1.5rem;
    right: 1.5rem;
  }
}
</style>
